import styled from 'styled-components';
import { navyMedium, coinGoldBorder } from '../../../themes/colors';

export const CoinsLabelWrapper = styled.span`
	font-size: 14px;
	font-weight: 400;
    font-family: ${props => props.theme.font};
    line-height: 20px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
	color: ${navyMedium};
    border: 1px solid ${coinGoldBorder};
    width: fit-content;
`;
